import { Button as CompassButton } from "@circleco/compass/components/Button";

import { t } from "@/i18n-js/instance";
import { classNames } from "@/react/helpers/twMergeWithCN";

import type { ConnectIconButtonsProps } from "./ConnectIconButtons";

export interface ConnectV4ButtonsProps extends ConnectIconButtonsProps {
  fullWidth?: boolean;
}

export const ConnectV4Buttons = ({
  className,
  flexDirection,
  fullWidth,
  handleAccept,
  handleIgnore,
  isAccepting,
  isIgnoring,
}: ConnectV4ButtonsProps) => {
  const buttonClassName = fullWidth ? "flex-1" : undefined;
  return (
    <div
      className={classNames(
        "flex gap-2",
        flexDirection,
        fullWidth ? "w-full" : "w-fit",
        className,
      )}
    >
      <CompassButton
        variant="primary"
        loading={isAccepting}
        disabled={isIgnoring}
        onClick={handleAccept}
        aria-label={t("member_directory.accept")}
        data-testid="accept-button"
        className={buttonClassName}
      >
        {t("member_directory.accept")}
      </CompassButton>
      <CompassButton
        variant="outline"
        loading={isIgnoring}
        disabled={isAccepting}
        onClick={handleIgnore}
        aria-label={t("member_directory.ignore")}
        data-testid="ignore-button"
        className={buttonClassName}
      >
        {t("member_directory.ignore")}
      </CompassButton>
    </div>
  );
};
